const typeofQueryParamToAdd = (url: string, query: string) => {
    if (url.includes("?")) {
        return `&${query}`
    }
    return `?${query}`
}

export default typeofQueryParamToAdd
